/**
 * A convenient way to set defaults for font styles (and handle mobile
 * friendliness) based on semantic HTML tags throughout the site
 */
import styled from 'styled-components'
import textStyles from './textStyles'
import colors from './colors'
import device from 'utilities/device'

const DefaultStyles = styled.div`
  h1 {
    ${textStyles.textStyleH1}
    font-family: 'Overpass', 'Open Sans', Arial, Helvetica, sans-serif;
    // color: $colorDarkBlue;

    @media ${device.laptop} {
      font-size: 48px;
      margin-top: 20px;
      line-height: 1.3em;
    }
    @media ${device.mobileL} {
      font-size: 32px;
      margin-top: 20px;
      line-height: 1.2em;
    }
  }
  h2 {
    ${textStyles.textStyleH2}
    font-family: 'Overpass', 'Open Sans', Arial, Helvetica, sans-serif;
    @media ${device.laptop} {
      font-size: 32px;
      line-height: 1.3em;
    }
  }
  h3 {
    ${textStyles.textStyleH3}
    // overriding some styles since some H4s in design should
    // really semantically be H3s
    font-size: 30px;
    font-family: 'Overpass', 'Open Sans', Arial, Helvetica, sans-serif;
    font-weight: 600;
    @media ${device.laptop} {
      font-size: 24px;
      line-height: 1.3em;
    }
  }
  h4 {
    ${textStyles.textStyleH4}
    font-family: 'Overpass', 'Open Sans', Arial, Helvetica, sans-serif;
  }
  a {
    color: ${colors.colorDarkBlue};
    text-decoration: none;
    &:link {
    }
    &:visited {
    }
    &:hover {
      color: ${colors.colorLightBlue};
      transition: color 0.2s ease;
    }
    &:active {
    }
  }
  p {
    ${textStyles.textStylesBigParagraph}
    line-height: 1.4em;
    @media ${device.laptop} {
      font-size: 20px;
    }
    @media ${device.mobileL} {
      font-size: 18px;
    }
  }
  input,
  textarea {
    @media ${device.laptop} {
      font-size: 18px;
    }
  }
`

export default DefaultStyles
